"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SimplePlanBoxSection;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _headlineLockup = _interopRequireDefault(require("@site/pattern-library-core/headline-lockup"));
var _section = _interopRequireDefault(require("@site/pattern-library-core/section"));
var _segmentToggle = _interopRequireDefault(require("../../../elements/other/segment-toggle"));
var _simplePlanBox = _interopRequireDefault(require("./simple-plan-box"));
var _scrollIndicator = _interopRequireDefault(require("../../product-merchandising/plan-box-section-subscription/scroll-indicator"));
var _groupToggle = _interopRequireDefault(require("./toggles/group-toggle"));
var _allPlansBanner = _interopRequireDefault(require("./all-plans-banner"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable complexity */
/* eslint-disable max-len */

/**
 * Local Imports
 */

const SimplePBSection = /*#__PURE__*/(0, _react2.styled)(_section.default)({
  name: "SimplePBSection",
  class: "pl-s16zjngu"
});
const PlanBoxHeadline = /*#__PURE__*/(0, _react2.styled)(_headlineLockup.default)({
  name: "PlanBoxHeadline",
  class: "pl-p1k2f5e"
});
const PlanGroupToggle = /*#__PURE__*/(0, _react2.styled)(_groupToggle.default)({
  name: "PlanGroupToggle",
  class: "pl-pb8skrq"
});
const SimpleToggle = /*#__PURE__*/(0, _react2.styled)(_segmentToggle.default)({
  name: "SimpleToggle",
  class: "pl-s1bme7ma"
});
const PlanBoxGrid = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "PlanBoxGrid",
  class: "pl-p1wb91hg",
  vars: {
    "p1wb91hg-0": [({
      cols
    }) => cols]
  }
});
const ScrollingPlanBoxContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ScrollingPlanBoxContainer",
  class: "pl-s1ry660h",
  vars: {
    "s1ry660h-0": [({
      overflows
    }) => overflows ? 'flex' : 'none'],
    "s1ry660h-4": [({
      pad
    }) => pad ? 'var(--planbox-edge-space)' : '0']
  }
});
const PlansBanner = /*#__PURE__*/(0, _react2.styled)(_allPlansBanner.default)({
  name: "PlansBanner",
  class: "pl-p1j53fj7"
});

/**
 * SimplePlanBoxSection Component.
 * @module SimplePlanBoxSection
 *
 * @param {Object} props React props
 * @param {String} props.id The id of the content item
 * @param {String} props._name The name of the content item
 * @param {Array} props.planGroups Plan Group Array
 * @param {Array} props.groupToggleMessage Below Group Toggle text
 * @param {Number} props.defaultGroup The index of the default group in the group toggle
 * @param {Object} props.toggleData Contains content for planbox toggle
 * @param {object} props.banner The banner content item
 * @param {Object} props.ctaOverrides CTA Style rules to use accross the component
 * @param {string} props.verticalMargin Vertical Layout Spacing Values
 * @param {Object} props.disabledPackages Packages that are visible but cannot be purchased
 * @returns {React.ReactElement} SimplePlanBoxSection Component
 * @public
 */
function SimplePlanBoxSection({
  id,
  _name,
  description,
  descriptionTooltip,
  disclaimer,
  disclaimerTooltip,
  eyebrow,
  eyebrowTag = 'h2',
  eyebrowLogo,
  heading,
  headlineSize = 'h1',
  headlineTag = 'h2',
  headlineLineLength = 5,
  textAlign = 'center',
  headingDataCy = 'simple-heading',
  verticalMargin,
  planGroups = [],
  defaultGroup = 0,
  toggleLeftText,
  toggleRightText,
  toggleTagText,
  reverseDefault,
  design,
  size,
  width,
  inverted,
  disabledPackages,
  partial,
  layout = 'default'
}) {
  const getValidIndex = idx => Math.max(0, Math.min(idx, planGroups.length));
  const scrollTarget = /*#__PURE__*/_react.default.createRef();
  const toggleData = {
    toggleLeftText,
    toggleRightText,
    toggleTagText,
    reverseDefault
  };
  const ctaOverrides = {
    ...(design && {
      design
    }),
    ...(size && {
      size
    }),
    ...(width && {
      width
    }),
    ...(inverted && {
      inverted
    })
  };
  const [toggled, setToggled] = (0, _react.useState)(toggleData?.reverseDefault);
  const [activeGroup, setActiveGroup] = (0, _react.useState)(planGroups[getValidIndex(defaultGroup)]);
  const [overflows, setOverflows] = (0, _react.useState)(true);
  const [pad, setPad] = (0, _react.useState)(true);
  (0, _react.useEffect)(() => {
    const minPlanBoxSize = 343;
    const maxPlanBoxSize = 424;
    const currentSize = scrollTarget?.current?.children[0]?.children[0]?.offsetWidth;
    setOverflows(minPlanBoxSize >= currentSize);
    setPad(maxPlanBoxSize !== currentSize);
  }, [activeGroup, scrollTarget]);
  const changeGroup = e => {
    setActiveGroup(planGroups[getValidIndex(Number(e?.target.value))]);
  };
  return /*#__PURE__*/_react.default.createElement(SimplePBSection, {
    id: `id-${id}`,
    _name: _name,
    verticalMargin: verticalMargin,
    style: {
      width: '100%'
    },
    dataCy: "simple-plan-box-section",
    padding: "none",
    textAlign: "center"
  }, /*#__PURE__*/_react.default.createElement(PlanBoxHeadline, {
    description: description,
    descriptionTooltip: descriptionTooltip,
    disclaimer: disclaimer,
    disclaimerTooltip: disclaimerTooltip,
    eyebrow: eyebrow,
    eyebrowTag: eyebrowTag,
    eyebrowLogo: eyebrowLogo,
    textAlign: textAlign,
    heading: heading,
    headlineLineLength: headlineLineLength,
    headlineTag: headlineTag,
    headlineSize: headlineSize,
    headingDataCy: headingDataCy
  }), /*#__PURE__*/_react.default.createElement(PlanGroupToggle, {
    id: id,
    changeHandler: changeGroup,
    activeGroupIdx: planGroups.indexOf(activeGroup),
    groups: planGroups
  }), !!activeGroup?.items && /*#__PURE__*/_react.default.createElement(ScrollingPlanBoxContainer, {
    overflows: overflows,
    pad: pad
  }, layout === 'reverse' && activeGroup?.banner && /*#__PURE__*/_react.default.createElement(PlansBanner, activeGroup.banner), (toggleLeftText || toggleRightText) && /*#__PURE__*/_react.default.createElement(SimpleToggle, (0, _extends2.default)({
    id: id,
    changeHandler: e => setToggled(e?.target?.value === 'toggled'),
    toggled: toggled,
    dynamicToggleSizing: true
  }, toggleData)), /*#__PURE__*/_react.default.createElement(PlanBoxGrid, {
    "data-cy": "plan-box-grid",
    cols: activeGroup?.items?.length,
    ref: scrollTarget
  }, activeGroup.items.slice(0, 4).map(({
    price,
    priceToggled,
    cta: itemCta,
    ctaToggled,
    ctaSecondary,
    ctaSecondaryToggled,
    description: itemDescription,
    descriptionToggled,
    planTagText,
    planTagTextToggled,
    ...rest
  }, idx) => {
    if (disabledPackages) {
      const {
        isLoading,
        message,
        value
      } = disabledPackages;
      if (isLoading) {
        itemCta.disabled = true;
      } else {
        itemCta.disabled = false;
        if (itemCta?.productPackage && value.includes(itemCta.productPackage)) {
          itemCta.disabled = true;
          itemCta.text = message;
        }
      }
    }
    return /*#__PURE__*/_react.default.createElement(_simplePlanBox.default, (0, _extends2.default)({
      col: idx + 1,
      key: idx,
      cta: toggled ? ctaToggled : itemCta,
      ctaSecondary: toggled ? ctaSecondaryToggled : ctaSecondary,
      description: toggled ? descriptionToggled ?? itemDescription : itemDescription,
      planTagText: toggled ? planTagTextToggled ?? planTagText : planTagText,
      price: toggled ? priceToggled : price,
      ctaOverrides: ctaOverrides,
      partial: partial
    }, rest));
  })), activeGroup?.items?.length > 1 && /*#__PURE__*/_react.default.createElement(_scrollIndicator.default, {
    elementArr: activeGroup.items.length,
    element: scrollTarget
  })), layout === 'default' && activeGroup?.banner && /*#__PURE__*/_react.default.createElement(PlansBanner, activeGroup.banner));
}
SimplePlanBoxSection.propTypes = {
  id: _propTypes.default.string,
  _name: _propTypes.default.string,
  planGroups: _propTypes.default.arrayOf(_propTypes.default.object),
  defaultGroup: _propTypes.default.number,
  toggleLeftText: _propTypes.default.string,
  toggleRightText: _propTypes.default.string,
  toggleTagText: _propTypes.default.string,
  reverseDefault: _propTypes.default.bool,
  design: _propTypes.default.oneOf(['inline', 'primary', 'secondary', 'merch', 'merch-secondary']),
  width: _propTypes.default.oneOf(['auto', 'full']),
  size: _propTypes.default.oneOf(['small', 'default']),
  inverted: _propTypes.default.bool,
  disabledPackages: _propTypes.default.object,
  partial: _propTypes.default.string,
  layout: _propTypes.default.oneOf(['default', 'reverse']),
  ..._headlineLockup.default.propTypes,
  ..._patternLibraryUtils.marginProps
};